import styled from 'styled-components';

export const ErrorMessage = styled.div`
  margin: 0.5rem 0;
  font-size: 1rem;
  color: red;
`;

export const UpdateStatusWrapper = styled.div<{ color?: string }>`
  height: 2rem;
  color: ${(props) => props.color || '#eae6e6'};
`;

export const TeamWrapper = styled.div<{ borderColor?: string | null }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.25rem;
  border: 2px solid red;
  border-color: ${(props) => props.borderColor || '#eae6e6'};
  border-radius: 5px;
  margin: 1rem 0.25rem;
`;

export const NameWrapper = styled.div`
  font-size: 1rem;
  margin: 0.25rem;
  display: flex;
  justify-content: start;
  flex-direction: column;
  input {
    font-size: inherit;
    margin-left: 0.25rem;
    width: 8rem;
  }
`;
export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem;
  position: relative;
`;

export const Button = styled.button`
  border-radius: 5px;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  height: 1.5rem;
  min-width: 5rem;
  font-size: 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;
